import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/vercel/path0/layouts/auth.vue").then(m => m.default || m)),
  "guest-app": defineAsyncComponent(() => import("/vercel/path0/layouts/guest-app.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("/vercel/path0/layouts/main.vue").then(m => m.default || m)),
  page: defineAsyncComponent(() => import("/vercel/path0/layouts/page.vue").then(m => m.default || m)),
  quote: defineAsyncComponent(() => import("/vercel/path0/layouts/quote.vue").then(m => m.default || m))
}